import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  GridModule,
  IconModule,
  ImageModule,
  PanelModule,
  ProximalModule,
  RatingModule,
  SectionHeaderModule,
  SpacingModule,
  TooltipModule,
} from '@frk/eds-components';
import { TranslateModule } from '@shared/translate/translate.module';
import { MorningStarDetailsComponent } from './morning-star-details.component';

@NgModule({
  declarations: [MorningStarDetailsComponent],
  imports: [
    CommonModule,
    GridModule,
    IconModule,
    ImageModule,
    PanelModule,
    ProximalModule,
    RatingModule,
    SectionHeaderModule,
    SpacingModule,
    TooltipModule,
    TranslateModule,
  ],
  exports: [MorningStarDetailsComponent],
})
export class MorningStarDetailsModule {}
